import React from "react";
import {ajaxPOST} from "../../ajax";
import config from "../../config";

export default function PromoCodeForm(){

    const [formData,setFormData] = React.useState({
        promoCode:"",
        description:"",
        discount:"100%"
      });

      var addPromoCode = async (e) => {
        e.preventDefault();
        var result = await ajaxPOST(config.promoCodes.EVENTS_API+"/new",formData);
        if(result.error) alert(result.message);
        alert("Promo Code Added");
        window.location.reload(true);
        return result;
      }
    
    


      return (<>
      
    
        <form onSubmit={addPromoCode} className="Form">
          <h2>Add Promo Code</h2>
          <label>
            Promo Code:
            <input type="text" name="promoCode" value={formData.promoCode} onChange={(e)=>setFormData({...formData,promoCode:e.target.value})}/>
          </label>
          <label>
            Description
            <input type="text" name="description" value={formData.description} onChange={(e)=>setFormData({...formData,description:e.target.value})}/>
          </label>
          <label>
            Discount:
            <input type="text" name="discount" value={formData.discount} onChange={(e)=>setFormData({...formData,discount:e.target.value})}/>
          </label>
          
          <button type="submit" onClick={addPromoCode}>Add Promo Code</button>
        </form>
        
    </>);
}